import PhaseShiftTheory from "../content/phase-shift.mdx";

/**
 * ABPhaseShift — Section 4: The AB phase shift, experiments, and the full linked view.
 */
export function ABPhaseShift() {
  return (
    <div className="flex flex-col gap-8 p-6 max-w-4xl mx-auto">
      <div className="mdx-content">
        <PhaseShiftTheory />
      </div>
    </div>
  );
}